import { observer } from "mobx-react";
import { IWalletConfigurationOnboardingScreenProps } from "../../wallet-configuration-onboarding-screen";
import OnBoardingScreenTitle from "../../../onboarding-screen-title/onboarding-screen-title";
import { HustleFreeReturnsIcon } from "../../icons/hastle-free-returns-icon";
import FontHeading2 from "../../../../../../components/fonts/font-heading2/font-heading2";
import FontHeading1 from "../../../../../../components/fonts/font-heading1/font-heading1";
import { FONT_COLOR, FONT_VARIANT } from "../../../../../../components/fonts/font-props";
import { GlobalCarrierAccessIcon } from "../../icons/global-carrier-access-icon";
import FontHeading4 from "../../../../../../components/fonts/font-heading4/font-heading4";
import { NoMinimumRequirementsIcon } from "../../icons/no-minimum-requirements-icon";
import { CompetitiveRatesIcon } from "../../icons/competitive-rates-icon";
import FontBody1 from "../../../../../../components/fonts/font-body1/font-body1";
import AHref from "../../../../../../components/ahref/ahref";
import { Button } from "../../../../../../components/inputs/button/button";
import { BUTTON_VARIANTS } from "../../../../../../components/inputs/button-variants";
import IconCard from "../../../../../../components/layouts/app-layout/app-header/personal-area-menu/icons/icon-card";
import { Note, NOTE_TYPE } from "../../../../../../components/note/note";
import FirstChargeBonusPromotion from "../../first-change-bonus-promotion/first-change-bonus-promotion";

const AddingPaymentMethodScreen: React.FC<IWalletConfigurationOnboardingScreenProps> = observer((props) => {
    const { store, walletStore, getTranslation, scope } = props;
    const readMoreLink = 'https://support.returngo.ai/wallet';

    return (
        <>
            <div className="wallet-configuration-onboarding-screen-title-wrapper">
                <OnBoardingScreenTitle
                    titleText={getTranslation("CONFIGURE_WALLET_SCREEN_TITLE_1",scope)}
                    descriptionText={getTranslation("CONFIGURE_WALLET_SCREEN_DESCRIPTION_1",scope)}
                    maxWidth={550}
                />
            </div>

            <div className="wallet-configuration-onboarding-screen-columns-wrapper">
                <div className="wallet-configuration-onboarding-screen-column">
                    <div className="sbr-benefits-block">
                        <FirstChargeBonusPromotion/>
                        <FontHeading2
                            color={FONT_COLOR.PRIMARY3}
                            variant={FONT_VARIANT.BOLD}
                        >
                            {getTranslation("WHY_USE_SBR",scope)}
                        </FontHeading2>
                        <div className="sbr-benefit">
                            <div className="sbr-benefit-icon"><GlobalCarrierAccessIcon /></div>
                            <div className="sbr-benefit-text">
                                <FontHeading4 variant={FONT_VARIANT.BOLD}>{getTranslation("GLOBAL_CARRIER_ACCESS",scope)}</FontHeading4>
                                <FontHeading4>{getTranslation("FOR_STREAMLINED_LOGISTICS",scope)}</FontHeading4>
                            </div>
                        </div>
                        <div className="sbr-benefit">
                            <div className="sbr-benefit-icon"><NoMinimumRequirementsIcon /></div>
                            <div className="sbr-benefit-text">
                                <FontHeading4 variant={FONT_VARIANT.BOLD}>{getTranslation("NO_MINIMUM_VOLUME_REQUIREMENTS",scope)}</FontHeading4>
                                <FontHeading4>{getTranslation("OFFERING_FULL_FLEXIBILITY",scope)}</FontHeading4>
                            </div>
                        </div>
                        <div className="sbr-benefit">
                            <div className="sbr-benefit-icon"><CompetitiveRatesIcon /></div>
                            <div className="sbr-benefit-text">
                                <FontHeading4 variant={FONT_VARIANT.BOLD}>{getTranslation("COMPETITIVE_RATES",scope)}</FontHeading4>
                                <FontHeading4>{getTranslation("TO_REDUCE_SHIPPING_RATES",scope)}</FontHeading4>
                            </div>
                        </div>
                    </div>
                    <div className="what-is-wallet-block">
                        <FontHeading2
                                color={FONT_COLOR.PRIMARY3}
                                variant={FONT_VARIANT.BOLD}
                        >
                            {getTranslation("WHAT_IS_THE_WALLET_TITLE",scope)}
                        </FontHeading2>

                        <div className="what-is-wallet-block-content">
                            <FontHeading4>{getTranslation("WHAT_IS_THE_WALLET_DESCRIPTION",scope)}</FontHeading4>

                            <Button
                                text={getTranslation("ADD_PAYMENT_METHOD", scope)}
                                variant={BUTTON_VARIANTS.PrimaryAccent}
                                leftIcon={() => <IconCard color={'var(--color-neutral-1-white)'} />}
                                onClick={store.addPaymentMethodHandler}
                            />

                            {walletStore.isAddingPaymentMethod ? (
                                <Note type={NOTE_TYPE.INFORMATION} body={getTranslation("WALLET_FORM_OPENED_IN_ANOTHER_TAB", scope)} />
                            ) : (
                                <div className="what-is-wallet-block-links">
                                    <FontBody1 color={FONT_COLOR.PRIMARY2}>{getTranslation("LEARN_MORE_ABOUT_SBR_AND_WALLET",scope)}</FontBody1>
                                    <AHref href={readMoreLink} target="_blank"><FontBody1 color={FONT_COLOR.ACCENT1} variant={FONT_VARIANT.BOLD}>{getTranslation("READ_MORE",scope)}</FontBody1></AHref>
                                </div>
                            )}    
                        </div>                    
                    </div>
                </div>
                <div className="wallet-configuration-onboarding-screen-column hastle-free-illustration">
                    <HustleFreeReturnsIcon />
                    <FontHeading1
                        variant={FONT_VARIANT.BOLD}
                        color={FONT_COLOR.PRIMARY1_10}
                    >
                        {getTranslation("HUSTLE_FREE_RETURN_SHIPPING",scope)}
                    </FontHeading1>
                </div>
            </div>
        </>
    );
});

export default AddingPaymentMethodScreen;